import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';
import * as _ from 'lodash';
import * as uuid from 'uuid';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-masked-text-input-element',
  templateUrl: './masked-text-input-element.component.html',
  styleUrls: ['./masked-text-input-element.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class MaskedTextInputElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;
  @Input() formValues: any | undefined;

  private inputId = 'inputid-' + uuid.v4();
  private maskedTextboxId = uuid.v4();

  public get inputValue(): string {
    let result = '';

    const inputName = this.getName();

    if (!_.isNil(inputName) && inputName !== '' && !_.isNil(this.formValues) && !_.isNil(this.formValues[inputName])) {
      result = this.formValues[inputName];
    }

    return result;
  }

  public set inputValue(value: string) {
    const inputName = this.getName();

    if (!_.isNil(inputName) && inputName !== '' && !_.isNil(this.formValues)) {
      this.formValues[inputName] = value;
    }

    setTimeout(() => {
      this.setMaskedTextboxClasses();
    }, 0);
  }

  constructor() { }

  ngOnInit(): void {
  }

  public getHiddenControlName(): string {
    return this.inputId;
  }

  public isHiddenControlValid(): boolean {
    let result = false;

    const element = document.getElementById(this.getHiddenControlName());

    if (!_.isNil(element)) {
      result = !element.classList.contains('ng-invalid');
    }

    return result;
  }

  public getControlName(): string {
    return 'input' + this.getName() + '-' + this.maskedTextboxId;
  }

  public getName(): string {
    return this.element?.name ?? '';
  }

  public getLabel(): string {
    return this.element?.label ?? '';
  }

  public getMask(): string {
    return this.element?.mask ?? '';
  }

  public getPattern(): string {
    let result = this.element?.pattern ?? '';

    // If custom validation has failed, make a pattern which won't be successful so the html input is set to invalid
    if (!this.isCustomValidationValid()) {
      result = '\\d(100)';
    }

    return result;
  }

  public isLabelVisible(): boolean {
    return this.getLabel() !== '' && this.isControlVisible();
  }

  public isControlVisible(): boolean {
    return !_.isNil(this.element) && !_.isNil(this.formValues);
  }

  public isRequired(): boolean {
    return this.element?.required ?? false;
  }

  private setMaskedTextboxClasses(): void {
    const element = document.getElementById(this.getControlName());

    if (!_.isNil(element)) {
      if (this.isHiddenControlValid()) {
        this.addClassToElement(element, 'ng-valid');
        this.RemoveClassFromElement(element, 'ng-invalid');
      } else {
        this.addClassToElement(element, 'ng-invalid');
        this.RemoveClassFromElement(element, 'ng-valid');
      }
    }
  }

  private addClassToElement(element: HTMLElement, className: string): void {
    if (!element.classList.contains(className)) {
      element.classList.add(className);      
    }
  }

  private RemoveClassFromElement(element: HTMLElement, className: string): void {
    if (element.classList.contains(className)) {
      element.classList.remove(className);      
    }
  }

  public isCustomValidationValid(): boolean {
    const validationMessage = this.getCustomValidationMessage();

    return _.isNil(validationMessage) || validationMessage === '';
  }

  public getCustomValidationMessage(): string {
    let result = '';

    if (!_.isNil(this.element?.validatorFunction) && _.isFunction(this.element?.validatorFunction)) {
      result = this.element?.validatorFunction(this.inputValue);
    }

    return result;
  }
}
